// Visual Builder integrations come in two SKUs during the move to flat pricing:
//   v3 - legacy, usage-billed (Power Blocks), licensed by the workspace license
//   vb - flat-priced, a normal per-integration license
export const LEGACY_VISUAL_BUILDER_SKU = 'v3'
export const FLAT_VISUAL_BUILDER_SKU = 'vb'

// True for an integration SKU whose flows are Visual Builder flows (either billing model)
export const isVBFlow = (sku) => sku === LEGACY_VISUAL_BUILDER_SKU || sku === FLAT_VISUAL_BUILDER_SKU

export const isFlatVisualBuilderSku = (sku) => sku === FLAT_VISUAL_BUILDER_SKU

// The integration_identifier (GraphQL enum form) a Visual Builder flow of this SKU saves with.
// Each SKU's flows are prefixed with that SKU, like every other integration type.
export const vbFlowIdentifier = (sku) => (isFlatVisualBuilderSku(sku) ? 'vb_vb' : 'v3_v3')
